export function padToLength(str: string, length: number, padStr = ' '): string {
  let padded = str;
  while (padded.length < length) {
    padded = padStr + padded;
  }
  return padded;
}
